export default "__VITE_ASSET__kDdiJPUh__"